<template>
  <form class="main-modal main-modal_w600" @submit.prevent="saveTool">
    <div class="main-modal__title">
      <p v-if="!isUpdate">{{ $t("forms.createTool") }}</p>
      <p v-else>{{ $t("forms.updateTool") }}</p>
    </div>

    <div class="main-form__box">
      <label class="main-form__label">{{ $t("listsHeader.toolName") }}</label>
      <input
        type="text"
        class="main-form__input"
        v-model="tool.name"
        :placeholder="$t('listsHeader.toolName')"
      />
    </div>

    <div class="main-form__box main-checkbox main-checkbox_flex">
      <input
        type="checkbox"
        v-model="tool.is_scooter"
        id="todo-1"
        class="main-checkbox__input"
      />
      <label for="todo-1" class="main-checkbox__label">
        <svg
          width="14"
          height="11"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.44912 8.6786L1.13019 5.25802L0 6.41462L4.44912 11L14 1.1566L12.8778 0L4.44912 8.6786Z"
            fill="#9BCD82"
          />
        </svg>
      </label>
      <label for="todo-1" class="main-checkbox__label-text">
        <span>{{ $t("listsHeader.canUseScooter") }}</span>
      </label>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">
        {{ $t("global.cancel") }}
      </span>
      <button
        type="submit"
        class="main-button main-button_success"
        :disabled="!isValid"
      >
        {{ $t("global.save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'toolsModal',
    props: {
        isUpdate: {
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            tool: 'tools/tool',
        }),
        isValid() {
            return !(this.tool.name === '' || this.tool.name === null)
        },
    },
    methods: {
        ...mapMutations({
            setState: 'tools/setState',
        }),
        saveTool() {
            this.$emit('done')
        },
    },
    beforeDestroy() {
        this.setState({
            key: 'tool',
            data: {
                name: '',
                is_scooter: false,
            },
        })
    },
}
</script>
